import React, { Component } from 'react'
import { Table } from 'reactstrap';
import Up from '../../res/up.svg';
import Down from '../../res/down.svg';
import Enter from '../../res/right-arrow.svg';

import Odometer from 'react-odometerjs-no-prop-types';

import '../../css/odom.css';

import { Sparklines, SparklinesLine } from 'react-sparklines';
import { Container, Row, Col } from 'reactstrap';

class MiniListing extends Component {

    formatNumber = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    render() {

        const priceDelta = this.props.price - this.props.prevPrice;

        let assetDelta = 100;

        if(this.props.prevPrice > 0) {
            assetDelta =  100 * (this.props.price - this.props.prevPrice) / this.props.prevPrice;
        }
        
        // generate test data
        // Array.from({length: 15}, () => Math.floor(Math.random() * 100))

        return (
            <div className="miniListing">
                <div className="miniHeader">
                    <h4>{ this.props.name }</h4>
                    <span className="deltaPrice" style={{ paddingTop: 2 }}>
                        <img src={(priceDelta) < 0 ? Down : Up} alt="Price Delta" />
                        <span className={(priceDelta) < 0 ? 'down' : 'up'}>
                            { (priceDelta < 0) ? '-' : '' }{ 
                                this.formatNumber(Math.abs(assetDelta).toFixed(2))
                            }%
                        </span>
                    </span>
                    <img className="enter" onClick={(e) => this.props.view(this.props.position, false) } src={Enter} alt=""/>
                </div>
                <div className="miniBody">
                    <Container style={{ padding: '0px 15px' }}>
                        <Row>
                            <Col style={{ padding: '0px' }}>
                                <div className="miniPrice">
                                    <h2 className={(priceDelta) < 0 ? 'down' : 'up'}><Odometer value={ parseFloat(this.props.price).toFixed(2) } options={{ duration:3000, format:"(,ddd).dd"}} /></h2>
                                </div>   
                            </Col>
                            <Col style={{ padding: '0px', paddingRight: 20 }}>
                                <Sparklines data={ this.props.priceData }>
                                    <SparklinesLine style={{ strokeWidth: 3, stroke: (priceDelta < 0) ? "#F53939" : "#06B07D", fill: "none" }} />
                                </Sparklines>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="best">
                    <Table style={{ color: 'white', margin: 0, marginTop: 10 }}>
                        <thead>
                            <tr>
                                <th style={{ border: 'none', padding: 0 }}>
                                    Bid
                                </th>
                                <th style={{ border: 'none', padding: 0 }}>
                                    Shares
                                </th>
                                <th style={{ border: 'none', padding: 0 }}>
                                    Ask
                                </th>
                                <th style={{ border: 'none', padding: 0 }}>
                                    Shares
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ border: 'none', padding: 0 }}>{ (this.props.bestBid !== undefined) ? '$' + this.formatNumber(parseFloat(this.props.bestBid).toFixed(2)) : 'N/A' }</td>
                                <td style={{ border: 'none', padding: 0 }}>{ (this.props.bestBidAmount !== undefined) ? this.formatNumber(parseFloat(this.props.bestBidAmount)) : 'N/A' }</td>
                                <td style={{ border: 'none', padding: 0 }}>{ (this.props.bestAsk !== undefined) ? '$' + this.formatNumber(parseFloat(this.props.bestAsk).toFixed(2)) : 'N/A' }</td>
                                <td style={{ border: 'none', padding: 0 }}>{ (this.props.bestAskAmount !== undefined) ? this.formatNumber(parseFloat(this.props.bestAskAmount)) : 'N/A' }</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}

export default MiniListing;